import {Operation} from "./Operation.js";


export class Sum extends Operation {

    static displayName() {
        return "Sum";
    }

    static isNumeric() {
        return true;
    }

    static isCategorical() {
        return false;
    }

    static handlesDate() {
        return false;
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = 0;
        }
        this.currValue += newValue || 0;
    }

}


export default Sum;
